import { useState } from "react";

import { Accordion, AccordionDetails, AccordionSummary, Box, Tab, Tabs, Typography } from "@mui/material";

import { useArcCoTabs } from "../../../hooks/useArcCoTabs";
import { ArrowDownIcon } from "../../Icons/Icons";
import { ArcCoContent } from "./ArcCoContent";
import { NoDataAlert } from "./NoDataAlert";

export const TabsSection = ({ tabs, selectedTab, onTabChange }) => (
  <Tabs value={selectedTab} onChange={onTabChange} sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
    {tabs.map((tab) => (
      <Tab key={tab.key} label={tab.label} />
    ))}
  </Tabs>
);

export const ArcCoWorksheet = ({
  arcCoCalculations, // Array of calculations by practice
  combinedCalculation, // Combined weighted calculation
  marketYearAveragePriceStatus = null,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const tabs = useArcCoTabs(arcCoCalculations, combinedCalculation);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const renderContent = () => {
    if (!arcCoCalculations?.length) {
      return <NoDataAlert message="No ARC-CO calculation data available" />;
    }

    if (tabs.length === 0) {
      return <NoDataAlert message="No calculation data available for this practice type" />;
    }

    if (tabs.length === 1) {
      return (
        <ArcCoContent
          tabs={tabs}
          selectedTab={0}
          arcCoCalculations={arcCoCalculations}
          combinedCalculation={combinedCalculation}
        />
      );
    }

    return (
      <>
        <TabsSection tabs={tabs} selectedTab={selectedTab} onTabChange={handleTabChange} />
        <ArcCoContent
          tabs={tabs}
          selectedTab={selectedTab}
          arcCoCalculations={arcCoCalculations}
          combinedCalculation={combinedCalculation}
        />
      </>
    );
  };

  return (
    <Accordion
      className="arc-plc-worksheet-accordion"
      disableGutters
      sx={{
        backgroundColor: "background.paper",
        "&.Mui-expanded": {
          backgroundColor: "grey.100",
        },
        borderRadius: "0.875rem !important",
        boxShadow: "none",
      }}
    >
      <AccordionSummary
        sx={{
          padding: 3,
          flexDirection: "row-reverse",
          "& .MuiAccordionSummary-content": {
            margin: "0 0 0 1rem",
          },
        }}
        expandIcon={
          <ArrowDownIcon
            sx={{
              width: 38,
              height: 38,
            }}
          />
        }
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, width: "100%" }}>
          <Typography
            sx={{ fontSize: "1.5rem !important", fontWeight: "700 !important", mb: "0 !important" }}
            variant="h5"
          >
            ARC-CO: Payment Calculation Worksheet
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This worksheet shows the step-by-step calculation for ARC-CO payments by irrigation practice.
            {marketYearAveragePriceStatus === "projected" && " (Based on projected MYA price)"}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>{renderContent()}</AccordionDetails>
    </Accordion>
  );
};
